module.exports = __webpack_public_path__ + "static/media/bg_body.d545574e.jpg";